import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import Home from './pages/Home';
import Exhibition from './pages/Exhibition';
import Artists from './pages/Artists';
import Goods from './pages/Goods';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import Cart from './pages/Cart';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '',
        element: <Home />,
      },
      {
        path: 'exhibition',
        element: <Exhibition />,
      },
      {
        path: 'artists',
        element: <Artists />,
      },
      {
        path: 'goods',
        element: <Goods />,
      },
      {
        path: 'cart',
        element: <Cart />,
      },
      {
        path: 'signup',
        element: <SignUp />,
      },
      {
        path: 'signin',
        element: <SignIn />,
      },
    ],
  },
]);

export default router;
